import { Flex, FlexProps } from '@mantine/core';
import styled from 'styled-components';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';

/**
 * @deprecated This component is deprecated and will be removed. Please utilise the columnBuilder instead.
 */
export const ExpandableCounterTagsCellContainer = styled.div`
	display: flex;
	align-items: center;
	flex-direction: row;
	flex: 1;
	min-width: 0;
	overflow: hidden;
`;

/**
 * @deprecated This component is deprecated and will be removed.
 */
export const ExpandableCounterTagsCellContentContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex: 1;
	min-width: 0;
	overflow: hidden;
	align-items: center;
	gap: 0.5rem;
`;

/**
 * @deprecated This component is deprecated and will be removed.
 */
export const ExpandableCounterTagsCellName = styled.div`
	color: ${({ theme }) => theme.v3.colors.dark[9]};
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
`;

/**
 * @deprecated This component is deprecated and will be removed.
 */
export const ExpandableCounterTagsCellBadgesContainer = styled(Flex)<FlexProps>`
	display: flex;
	flex-wrap: wrap;
	gap: 0.25rem;
`;

/**
 * @deprecated This component is deprecated and will be removed.
 */
export const ActionCellContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
`;

export const TextWithPotentialIndicator = styled.div<{ $indicator?: boolean }>`
	${({ $indicator }) =>
		$indicator
			? `
				display: list-item;
				list-style-type: disc;
				list-style-position: inside;
				&::marker {
					color: ${defaultTheme.v3.colors.gray[8]};
				
			`
			: ''}
`;
